import * as React from "react";
import { IconButton, Tooltip } from "@mui/material";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { useNavigate } from "react-router-dom";
import { useRecordContext, usePermissions } from "react-admin";
import { can } from "../auth/can";

export function TeamAssignmentButton() {
  const record = useRecordContext();
  const navigate = useNavigate();
  const { permissions, isLoading } = usePermissions();

  if (!record || isLoading) return null;

  if (!can(permissions, "teams", "assign")) return null;

  return (
    <Tooltip title="Team-Zuordnung">
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation(); // 👈 wichtig, sonst rowClick
          navigate(`/team-assignments?teamId=${record.id}`);
        }}
      >
        <GroupAddIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
